// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app__MLRadioTypelistComponent__radioWithTooltip{display:inline-block}", "",{"version":3,"sources":["webpack://./../common/modules-react/ml-components-platform-react/MLRadioTypelistComponent/MLRadioTypelistComponent.module.scss"],"names":[],"mappings":"AAAA,iDACI,oBAAA","sourcesContent":[".radioWithTooltip {\n    display: inline-block;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"radioWithTooltip": "app__MLRadioTypelistComponent__radioWithTooltip"
};
export default ___CSS_LOADER_EXPORT___;
